<template>
    <div class="ui-tooltip-place">
        <core-portal :target="target">
            <transition name="fade" @enter="beforeShow">
                <div class="ui-tooltip" :style="style" v-if="show" @click.stop>
                    <div class="ui-tooltip__tail"></div>
                    <div class="ui-tooltip__content">
                        <span class="ui-tooltip__close" @click="close">close</span>
                        <slot />
                    </div>
                </div>
            </transition>
        </core-portal>
        <core-portal :target="target">
            <transition name="overlay">
                <div class="ui-tooltip-overlay" v-if="show"></div>
            </transition>
        </core-portal>
    </div>
</template>

<script>
    import CorePortal from '@/components/core/portal'

    export default {
        components: {
            CorePortal
        },
        data () {
            return {
                timeout: null,
                show: false,
                targetRect: null,
                position: {
                    x: 0,
                    y: 1
                }
            }
        },
        computed: {
            style () {
                return {
                    left: this.position.x + 'px',
                    top: this.position.y + 'px'
                }
            },
            target () {
                if (window.innerWidth > 768) {
                    return document.body
                } else {
                    return '.game__section'
                }
            }
        },
        methods: {
            open (targetElement) {
                this.targetRect = targetElement.getBoundingClientRect()
                this.show = true
                this.timeout = setTimeout(() => {
                    document.addEventListener('click', this.close)
                }, 200)
            },
            close () {
                this.show = false
                clearTimeout(this.timeout)
                document.removeEventListener('click', this.close)
            },
            beforeShow (element) {
                const tooltipRect = element.getBoundingClientRect()
                const scrollTop = document.scrollingElement.scrollTop

                this.position.x = this.targetRect.x - tooltipRect.width
                this.position.y = scrollTop + this.targetRect.y + (this.targetRect.height/2) - (tooltipRect.height/2)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .ui-tooltip {
        position absolute
        z-index 200
        +layout-sm() {
            top 0!important
            left 0!important
            right 0!important
            bottom 0!important
        }
        &__content {
            background-color #121258
            color #C5E5FB
            padding 3rem 3.7rem
            position relative
            +layout-sm() {
                display flex
                width 100%
                justify-content center
                align-items center
                height 100%
                background-color transparent
            }
        }
        &__tail {
            position absolute
            top 50%
            left 100%
            transform translate(0, -50%)
            +layout-sm() {
                display none
            }
            &:after {
                content ""
                display block
                border-left 1.7rem solid #121258
                border-top 1.7rem solid transparent
                border-bottom 1.7rem solid transparent
            }
        }
        &__close {
            position absolute
            top 0
            right 0
            width 3.8rem
            height @width
            display inline-flex
            background-color #121258
            font-size: 0
            background-image url('~@/assets/icons/cross.svg')
            background-repeat no-repeat
            background-position center
            cursor pointer
            transition background-color 0.3s ease
            &:hover {
                background-color #3665f3
            }
            &:active {
                opacity 0.9
            }
        }
    }

    .ui-tooltip-overlay {
        display none
        +layout-sm() {
            display block
            position absolute
            top 0
            left 0
            right 0
            bottom 0
            background-color #121258
            opacity 1
            z-index 199
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition opacity 0.3s ease, transform 0.3s ease
        +layout-sm() {
            transition opacity 0.3s ease, transform 0.5s ease
        }
    }

    .fade-enter,
    .fade-leave-to {
        opacity 0
        transform translate(2rem, 0)
        +layout-sm() {
            transform scale(0)
        }
    }

    .overlay-enter-active,
    .overlay-leave-active {
        transition opacity 0.3s ease
    }

    .overlay-enter,
    .overlay-leave-to {
        opacity 0
    }
</style>
